import { InputProps, SxProps, Theme } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import { forwardRef, ReactNode } from 'react'
import HintLabel from '../HintLabel'
import InputBase from './InputBase'

export type Props = InputProps & {
  helperText?: ReactNode
  label?: ReactNode
  labelHint?: string
  placeholder?: string
  sx?: SxProps<Theme>
}

const TextField = forwardRef((props: Props, _) => {
  const { label, labelHint, helperText, sx, ...inputProps } = props

  return (
    <FormControl error={inputProps.error} sx={sx} variant="standard">
      <HintLabel htmlFor={inputProps.id} hint={labelHint}>
        {label}
      </HintLabel>
      <InputBase {...inputProps} sx={sx} />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
})

export default TextField
